import alignElement from './align/alignElement';
import alignPoint from './align/alignPoint';

export { alignElement, alignPoint };

export default alignElement;


//////////////////
// WEBPACK FOOTER
// ./~/dom-align/es/index.js
// module id = 1089
// module chunks = 14